import i18n from '@/plugins/i18n/locale';

/**
 * 全角カナかどうか検証する
 * https://ja.wikipedia.org/wiki/Unicode一覧_3000-3FFF
 */
const fullWidthKana: any = {
  validate: (value: any): boolean => {
    if (Array.isArray(value)) {
      return value.every((v: any) => fullWidthKana.validate(v));
    }
    if (value == null || value === '') {
      return true;
    }
    if (typeof value !== 'string') {
      return false;
    }
    return Array.prototype.every.call(value, contains);
  },
  message: (field: string, values: any) => {
    values._field_ = `${i18n.t(`form.fields.${field}`)}`;
    return i18n.t(`validations.custom.${values._rule_}`, values);
  }
};

const contains = (c: string): boolean => {
  return (c >= 'ァ' && c <= 'ヺ') || c === 'ー';
};
export default fullWidthKana;
